import { graphql, useStaticQuery } from 'gatsby';
import type { IGatsbyImageData } from 'gatsby-plugin-image';
import { withMarketplaceIntegrations } from '@lucid/utils';

import type { Lucid } from '../types/types';

export type IntegrationItem = {
  id: string;
  title: string;
  image: IGatsbyImageData;
};

const useMarketplaceIntegrations = () => {
  const integrationsQuery = useStaticQuery<Lucid.Query.Hooks.UseMarketplaceIntegrations>(graphql`
    query useMarketplaceIntegrationsQuery {
      allMarketplaceIntegration(sort: { title: ASC }) {
        nodes {
          packageId
          title
          products
          icon48 {
            childImageSharp {
              gatsbyImageData(placeholder: TRACED_SVG, quality: 100)
            }
          }
        }
      }
    }
  `);

  return withMarketplaceIntegrations(integrationsQuery);
};

export default useMarketplaceIntegrations;
